import { Component, OnInit, Input, Injector } from '@angular/core';
import { MasonryItemModel } from '../../masonry/masonry.component';
import { ConsumerModel } from '../../../models/consumer/consumer.model';
import { MeterConsumptionItemComponent } from '../grid-item/meter-consumption-item.component';
import { TarrifItemComponent } from '../grid-item/tarrif-item.component';
import { DataService } from '../../../services/data.service';
import { ConsumerService } from '../../../services/consumer.service';
import { ConsumerDetailInjector } from '../consumer-detail-injector';
import { WidgetType } from '../../../models/consumer/widget-issues-type.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'consumer-detail-tarrif-consumption',
  templateUrl: './consumer-detail-tarrif-consumption.component.html',
})
export class ConsumerDetailTarrifConsumptionComponent implements OnInit {
    public subscriptions: any[] = [];
    @Input() clientId: number;
    @Input() consumerId: string;
    @Input() consumerIssues: any[] = [];
    @Input() consumer: ConsumerModel;

    constructor(private dataService: DataService,
        private route: ActivatedRoute,
        private injector: Injector) { }

    masonryItems: MasonryItemModel[] = [];
    consumerHasPayg: boolean = false;
    consumerHasBilling: boolean = false;
    accountInjector: any;
    billInjector: any;
    creditStatusInjector: any;
    meterInjector: any;
    paymentInjector: any;
    tarrifInjector: any;
    meterConsumptionIssues: any[];
    paymentsIssues: any[];

    ngOnInit() {
        this.consumerId = this.route.snapshot.params['consumerId'];
        this.clientId = this.route.parent.snapshot.params['clientId'];
        this.consumerHasPayg = (this.consumer.consumerType === 'PAYG') ? true : false;
        this.consumerHasBilling = (this.consumer.consumerType === 'Billing') ? true : false;
    }

    ngOnChanges(changes: any) {
        for (let propName in changes) {
            let chng = changes[propName];
            if (propName == "clientId") { this.clientId = chng.currentValue; }
            if (propName == "consumerId") { this.consumerId = chng.currentValue; }
            if (propName == "consumer") { this.consumer = chng.currentValue; }
            if (propName == "consumerIssues") { this.consumerIssues = chng.currentValue; }
        }

        if(this.consumerIssues) {
            this.meterConsumptionIssues = this.consumerIssues.filter(x => x.relatedWidget == WidgetType.MeterConsumption);
            this.paymentsIssues = this.consumerIssues.filter(x => x.relatedWidget == WidgetType.Payments);

            this.meterInjector = Injector.create([
                { provide: ConsumerDetailInjector, useValue: new ConsumerDetailInjector(this.meterConsumptionIssues ? this.meterConsumptionIssues : [], this.consumerHasPayg, this.consumerHasBilling) }
            ], this.injector);

            this.paymentInjector = Injector.create([
                { provide: ConsumerDetailInjector, useValue: new ConsumerDetailInjector(this.paymentsIssues ? this.paymentsIssues : [], this.consumerHasPayg, this.consumerHasBilling) }
            ], this.injector);

            this.tarrifInjector = Injector.create([
                { provide: ConsumerDetailInjector, useValue: new ConsumerDetailInjector(this.paymentsIssues ? this.paymentsIssues : [], this.consumerHasPayg, this.consumerHasBilling) }
            ], this.injector);

        }

        if (this.consumer) {
            this.consumerHasPayg = (this.consumer.consumerType === 'PAYG') ? true : false;
            this.consumerHasBilling = (this.consumer.consumerType === 'Billing') ? true : false;

            this.meterInjector = Injector.create([
                { provide: ConsumerDetailInjector, useValue: new ConsumerDetailInjector(this.meterConsumptionIssues ? this.meterConsumptionIssues : [], this.consumerHasPayg, this.consumerHasBilling) }
            ], this.injector);

            this.paymentInjector = Injector.create([
                { provide: ConsumerDetailInjector, useValue: new ConsumerDetailInjector(this.paymentsIssues ? this.paymentsIssues : [], this.consumerHasPayg, this.consumerHasBilling) }
            ], this.injector);

            this.tarrifInjector = Injector.create([
                { provide: ConsumerDetailInjector, useValue: new ConsumerDetailInjector(this.paymentsIssues ? this.paymentsIssues : [], this.consumerHasPayg, this.consumerHasBilling) }
            ], this.injector);
           
            if (this.consumerHasPayg) {
                this.masonryItems = [
                    {
                        component: MeterConsumptionItemComponent,
                        injector: this.meterInjector
                    },
                    {
                        component: TarrifItemComponent,
                        injector: this.tarrifInjector
                    }
                ]
            } else if (this.consumerHasBilling) {

                this.masonryItems = [
                    {
                        component: MeterConsumptionItemComponent,
                        injector: this.meterInjector
                    },
                    {
                        component: TarrifItemComponent,
                        injector: this.tarrifInjector
                    }
                ]
            }

            this.subscriptions.push(this.dataService.meterConsumptionItemComponentResolved.subscribe(
                result => this.masonryItems.find(x => x.component == MeterConsumptionItemComponent).isExpandable = result
            ));
        }
    }

}
